/** Nội dung đối ứng dùng chung cho lịch sử số dư và tiền cọc. */
export const transferHistoryText = row => {
    if (!row?.transfer_code) return null;
    const customerName = row.counterparty_name;
    const customerCode = row.counterparty_code;
    const customer = customerName && customerCode
        ? `${customerName} - ${customerCode}`
        : customerName || customerCode || 'khách hàng đối ứng';
    if (row.is_transfer_reversal) {
        const original = row.original_transfer_code ? ` ${row.original_transfer_code}` : '';
        return row.transfer_direction === 'OUT'
            ? `Hoàn trả cho ${customer} từ giao dịch${original}`
            : `Nhận lại từ ${customer} do hoàn tác giao dịch${original}`;
    }
    return row.transfer_direction === 'OUT' ? `Chuyển cho ${customer}` : `Nhận từ ${customer}`;
};

export const transferCodeText = row => row?.transfer_code ? `Lần chuyển ${row.transfer_code}` : '—';
